export default [
	{
		id: 0,
		title: 'Заголовок уведомления 11',
		body: 'Товарищи! начало повседневной работы по формированию позиции представляет собой '
			+ 'интересный эксперимент проверки позиций, занимаемых участниками в отношении',
		type: 'text',
		priority: 'high',
		isReaded: false,
		createdAt: new Date(),
		readedAt: null,
	},
	{
		id: 1,
		title: 'Заголовок уведомления',
		body: 'Товарищи! начало повседневной работы по формированию позиции представляет собой '
			+ 'интересный эксперимент проверки позиций, занимаемых участниками в отношенииТоварищи! '
			+ 'начало повседневной работы по формированию позиции представляет собой интересный '
			+ 'эксперимент проверки позиций, занимаемых участниками в отношенииТоварищи! начало '
			+ 'повседневной работы по формированию позиции представляет собой интересный эксперимент '
			+ 'проверки позиций, занимаемых участниками в отношенииТоварищи! начало повседневной'
			+ ' работы по формированию позиции представляет собой интересный эксперимент проверки'
			+ ' позиций, занимаемых участниками в отношении',
		type: 'text',
		priority: 'regular',
		isReaded: true,
		createdAt: new Date(),
		readedAt: null,
	},
	{
		id: 2,
		title: 'Заголовок уведомления',
		body: 'Товарищи! начало повседневной работы по формированию позиции представляет собой '
			+ 'интересный эксперимент проверки позиций, занимаемых участниками в отношенииТоварищи! '
			+ 'начало повседневной работы по формированию позиции представляет собой интересный '
			+ 'эксперимент проверки позиций, занимаемых участниками в отношенииТоварищи! начало'
			+ ' повседневной работы по формированию позиции представляет собой интересный эксперимент'
			+ ' проверки позиций, занимаемых участниками в отношенииТоварищи! начало повседневной '
			+ 'работы по формированию позиции представляет собой интересный эксперимент проверки '
			+ 'позиций, занимаемых участниками в отношении',
		type: 'text',
		priority: 'regular',
		isReaded: true,
		createdAt: new Date('2020-11-03'),
		readedAt: null,
	},
	{
		id: 3,
		title: 'Заголовок уведомления',
		body: 'Товарищи! начало повседневной работы по формированию позиции представляет собой '
			+ 'интересный эксперимент проверки позиций, занимаемых участниками в отношении',
		type: 'text',
		priority: 'regular',
		isReaded: false,
		createdAt: new Date('2020-11-03'),
		readedAt: null,
	},
];
